
import locale from 'element-ui/lib/locale/lang/zh-CN';

export default {
  message: '你好 i18n !!',
  webm: '/zh.webm',
  mpfour: '/zh.mp4',
  // header
  home: '首页',
  products: '产品与方案',
  machining: '加工中心',
  about: '关于登越',
  news: '企业资讯',
  contact: '联系我们',
  chooseLanguage: '中文',
  home_page: {
    company_detail: '2000年12月，几个小伙伴拍脑袋一商量，成立了一家专门生产膨体聚四氟乙烯（ePTFE）微孔膜的企业，然后给产品取了个商标名叫"DENTIK"。',
    product_detail: '膨体聚四氟乙烯（ePTEFE）微孔膜 及延伸产品方案解决者',
    enterpeise_vedio: 'ENTERPEISE VIDEO',
    know_more_slogan: '专注于ePTFE薄膜开发及各行业的应用，20年如一日。',
    lamination_tech: '贴合技术',
    lamination_tech_desc1: '高端的粘接材料，领先的贴合工艺，',
    lamination_tech_desc2: '令各类织物功能卓著，如您所愿。',
    exhibition_infos: '展会信息',
    report_inofs: '报告',
    data_infos: '相关资料',
    read_more: 'Read More',
    sewing_tech: '缝纫技术',
  },
  contact_page: {
    contact: '联系我们',
    contact2: '0574-62160116',
    OnlineInquiry:'在线询盘',
    form:{
      theme:'主题',
      content:'内容',
      CompanyType:{
        title:'公司类型',
        type:['公司','个体经营']
      },
      CorporateName:'公司名称',
      name:'联系姓名',
      email:'邮箱',
      tel:'电话',
      website: '公司网址',
    },
    formRules:{
      theme:'请输入主题',
      content:'请输入内容',
      CompanyType:'请选择公司类型',
      CorporateName:'请输入公司名称',
      name:'请输入联系姓名',
      email:'请输入邮箱',
      tel:'请输入电话'
    },
    success:'提交成功'
  },
  know_more: '了解更多',
  see_more: '查看更多',
  check_more: '查看所有产品与方案',
  online_customer_service: '在线客服',
  online_chat: '在线客服',
  hot_line: '热线电话',
  scan_me: '扫我关注',
  foot: {
    company: '宁波登越新材料科技有限公司',
    tel: '0574-62160116',
    address: '中国浙江省余姚市泗门镇固北路88号',
    products: [
      {
        id: '18',
        title: '服装用ePTFE膜',
      },
      {
        id: '19',
        title: 'ePTFE精密过滤膜',
      },
      {
        id: '22',
        title: 'ePTFE电子透气膜',
      },
      {
        id: '23',
        title: 'ePTFE医用驻极体膜',
      },
      {
        id: '24',
        title: '户外运动面料',
      },
      {
        id: '25',
        title: '消防防护面料',
      },
    ],
    machining: ['贴合技术', '缝制技术'],
    about: ['企业简介', '资质荣誉', '知识产权', '品牌合作'],
    news: ['展会信息', '报告', '相关文章'],
    webbuilding: '网站建设：三盛网络',
  },
  // element-ui
  ...locale,
};
